import BaseApi from 'api/core/baseApi';
import { ENDPOINTS } from 'api/config/endpoints';

class OrderApi extends BaseApi {
  constructor() {
    super(ENDPOINTS.ORDER);
  }

  getOrderLines(orderId) {
    return this.httpClient.get(
      `${this.getResourceUrl()}${orderId}/order-lines/`,
    );
  }

  cancelOrders(orderId, shipmentLineIds) {
    return this.httpClient.patch(`${this.getResourceUrl()}${orderId}/cancel/`, {
      shipment_line_id_list: shipmentLineIds,
    });
  }

  connectOrders(orderId) {
    return this.httpClient.patch(
      `${this.getResourceUrl()}${orderId}/relation-connect/`,
      {},
    );
  }

  getOrderHistory(orderId) {
    return this.httpClient.get(`${this.getResourceUrl()}${orderId}/history/`);
  }
}

export default new OrderApi();
